import { request, getMapiHeaders } from './request';

/**
 * 查询用户信息
 * http://gzh-ads.babytree-dev.com/api/zeus/0.0.1-SNAPSHOT/user/getUserByLoginString.html#%E6%A0%B9%E6%8D%AEloginstring%E8%8E%B7%E5%8F%96%E7%94%A8%E6%88%B7%E4%BF%A1%E6%81%AF-2-javacode
 */
export const queryUserInfos = params => {
  return request
    .post({
      url: `/newapi/api/user/getUserByLoginString`,
      data: params,
      options: {
        service: 'mapiweb',
        loading: false,
        toast: false
      },
      axiosOptions: {
        headers: getMapiHeaders(),
        withCredentials: false
      }
    })
    .then((res = {}) => {
      const { data } = res;
      return data;
    });
};

export const getJsConfig = params => {
  return request
    .post({
      url: `/newapi/api/weixin/getJsConfig`,
      data: params,
      options: {
        service: 'mapiweb',
        loading: false,
        toast: false
      },
      axiosOptions: {
        headers: getMapiHeaders(),
        withCredentials: false
      }
    })
    .then((res = {}) => {
      const { data } = res;
      return data;
    });
};
